module.exports = __webpack_public_path__ + "static/media/8.dd02b585.jpg";